// src/App.js
import React, { useState } from 'react';
import HomePage from './components/HomePage';

import EthApp from './chain/eth/App';
import UsdtApp from './chain/usdt/App';
import SolApp from './chain/sol/App';

function App() {
  const [selectedChain, setSelectedChain] = useState(null);

  const disconnectProps = { onDisconnect: () => setSelectedChain(null) };

// Add this near the top of your index.js / App.js entry point
const originalError = window.console.error;
window.console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed')) {
    return; // Ignore this specific harmless warning
  }
  originalError.call(window.console, ...args);
};

  switch (selectedChain) {
    case 'eth':
      return <EthApp {...disconnectProps} />;
    case 'usdt':
      return <UsdtApp {...disconnectProps} />;
    case 'sol':
      return <SolApp {...disconnectProps} />;
    default:
      return <HomePage onSelectChain={(chain) => setSelectedChain(chain)} />;
  }
}

export default App;